import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { Protected } from "./components/Protected";
import { ForgotPasswordPage } from "./features/auth/ForgotPasswordPage";
import { LoginPage } from "./features/auth/LoginPage";
import { RegisterPage } from "./features/auth/RegisterPage";
import { FeedPage } from "./features/feed/FeedPage";
import { OpportunityDetailPage } from "./features/feed/OpportunityDetailPage";
import { NotificationsPage } from "./features/notifications/NotificationsPage";
import { NewTransactionPage } from "./features/transactions/NewTransactionPage";
import { TransactionsPage } from "./features/transactions/TransactionsPage";
import { SimulatorPage } from "./features/simulator/SimulatorPage";
import { PortfolioDetailPage } from "./features/portfolio/PortfolioDetailPage";
import { PortfoliosPage } from "./features/portfolio/PortfoliosPage";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route index element={<Navigate to="/portfolios" replace />} />
        <Route path="/portfolios" element={<PortfoliosPage />} />
        <Route path="/portfolios/:id" element={<PortfolioDetailPage />} />
        <Route path="/portfolios/:id/transactions" element={<TransactionsPage />} />
        <Route path="/portfolios/:id/transactions/new" element={<NewTransactionPage />} />
        <Route path="/feed" element={<FeedPage />} />
        <Route path="/opportunities/:id" element={<OpportunityDetailPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/simulator" element={<SimulatorPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
